import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IIntegrationTopic } from '@core/services/integrations/integrations.interface';

@Injectable({
	providedIn: 'root',
})
export class IntegrationState {
	private topics$: BehaviorSubject<IIntegrationTopic[]> = new BehaviorSubject<IIntegrationTopic[]>([]);
	private updating$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private _hasSlack$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private _hasTeams$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() {}

	isUpdating$() {
		return this.updating$.asObservable();
	}

	hasSlack(): Observable<boolean> {
		return this._hasSlack$.asObservable();
	}

	hasTeams(): Observable<boolean> {
		return this._hasTeams$.asObservable();
	}

	setSlack(value: boolean): void {
		this._hasSlack$.next(value);
	}

	setTeams(value: boolean): void {
		this._hasTeams$.next(value);
	}

	setUpdating(isUpdating: boolean) {
		this.updating$.next(isUpdating);
	}

	getTopics(): Observable<IIntegrationTopic[]> {
		return this.topics$.asObservable();
	}

	getTopicsValue(): IIntegrationTopic[] {
		return this.topics$.getValue();
	}

	setTopics(topics: IIntegrationTopic[]): void {
		return this.topics$.next(topics);
	}
}
